import CompanyIntroduction_2 from "@/views/CompanyIntroduction_2.vue";
import ContactUs from "@/views/ContactUs.vue";
import GeteyesIntroduction from "@/views/GeteyesIntroduction.vue";
import HomeV2 from "@/views/HomeV2.vue";
import Qmeet from "@/views/Qmeet.vue";
import Recruit from "@/views/Recruit.vue";
import SiIntroductionV3 from "@/views/SiIntroductionV3.vue";
import Terms from "@/views/Terms.vue";
import SiIntroduction_2 from "@/views/SiIntroduction_2.vue";
import { createRouter, createWebHistory } from "vue-router";

export default createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    // 항상 페이지의 상단으로 이동
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      component: HomeV2,
    },
    {
      // 모든 잘못된 경로를 catch-all로 처리
      path: "/:catchAll(.*)",
      redirect: "/",
    },
    {
      path: "/company",
      component: CompanyIntroduction_2,
    },
    {
      path: "/testingservice",
      component: SiIntroduction_2,
    },
    {
      path: '/development',
      component: SiIntroductionV3,
    },
    {
      path: "/geteyes",
      component: GeteyesIntroduction,
    },
    {
      path: "/recruit",
      component: Recruit,
    },
    {
      path: "/contactus",
      component: ContactUs,
    },
    {
      path: "/qmeet",
      component: Qmeet,
    },
    {
      path: "/terms",
      component: Terms,
    },
  ],
});
